import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { hasOpenDialogs } from '../../../../../../core/functions/dialog-helper';
import { FileHelper } from '../../../../../../core/helpers/file/file-helper';
import { AttachmentOperationComponent } from '../../components/attachment/attachment-operation/attachment-operation.component';

@Injectable({
    providedIn: 'root',
})
export class AttachmentManagementService {
    private readonly dialog = inject(MatDialog);

    /**
     * Displays the attachment management dialog for the specified application ID.
     *
     * @param applicationId The ID of the application for which to manage attachments.
     */
    displayAttachmentManagementDialog(applicationId: string): void {
        if (hasOpenDialogs(this.dialog)) {
            return;
        }

        this.dialog.open(AttachmentOperationComponent, {
            width: '900px',
            disableClose: true,
            data: { applicationId },
        });
    }

    /**
     * Initiates a download of a given Blob object by creating a temporary
     * anchor element and programmatically clicking it. The file will be
     * saved to the user's device with the filename from the form control.
     *
     * @param blob The Blob object representing the file content to download.
     * @param filename The desired filename for the downloaded file.
     */
    downloadAttachmentBlob(blob: Blob, filename: string): void {
        FileHelper.downloadBlobFile(blob, filename);
    }
}
